import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { BreadCrumbMenu } from '../models/breadcrumb-menu';

const linkCount: number = 3;

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  recentVisitList: BreadCrumbMenu[] = [];
  homePage: BreadCrumbMenu;
  constructor(private route: Router) {
    this.homePage = { title: 'Dashboard', routerLink: '/dashboard', label: 'Dashboard' };
    this.recentVisitList = [this.homePage];
  }

  addToMenu(title: string, params: any = null) {
    const routerLink = this.route.url.split('?')[0];
    const queryParams = params || this.route.parseUrl(this.route.url).queryParams;
    const sameItem = this.recentVisitList
      .find(p => p.routerLink === routerLink && _.isEqual(p.queryParams, queryParams));
    if (sameItem) {
      let index = this.recentVisitList.indexOf(sameItem);
      // if this is the last link, then update the title because some page's title will be updated after a http request
      if (index === this.recentVisitList.length - 1) sameItem.title = title;
      // if click back the previous link, then remove latest link
      if (index < this.recentVisitList.length - 1)
        this.recentVisitList.splice(this.recentVisitList.length - 1, 2);
    } else {
      while (this.recentVisitList.length > linkCount - 1) this.recentVisitList.splice(1, 1);
      this.recentVisitList.push({ title, routerLink, queryParams, label: title });
    }
  }


  addLinkToList(title: string, routerLink: string, queryParams: any) {
    // insert to first
    let sameItem = this.recentVisitList
      .find(p => p.routerLink === routerLink && _.isEqual(p.queryParams, queryParams));
    if (sameItem) {
      let index = this.recentVisitList.indexOf(sameItem);
      // if this is the last link, then update the title because some page's title will be updated after a http request
      if (index === this.recentVisitList.length - 1) sameItem.title = title;
      // if click back the previous link, then remove latest link
      if (index < this.recentVisitList.length - 1)
        this.recentVisitList.splice(this.recentVisitList.length - 1, 2);
    } else {
      while (this.recentVisitList.length > linkCount - 1) this.recentVisitList.splice(1, 1);
      this.recentVisitList.push({ title, routerLink, queryParams, label: title });
    }
  }
  get RecentLinks() {
    return this.recentVisitList;
  }

  get HomePage() {
    if (this.homePage && !this.homePage.routerLink.startsWith('/')) {
      this.homePage = {
        ...this.homePage,
        routerLink: '/' + this.homePage.routerLink
      }
    }
    return this.homePage;
  }

  clean() {
    this.recentVisitList = [this.homePage];
  }
}
